import reportTypes from './report-types';
import pageRoutes from 'Constants/page-routes';

export default {
    [reportTypes.shareholderListTemplate]: pageRoutes.reportingShareholderList,
    [reportTypes.shareDetailTemplate]: pageRoutes.reportingShareDetail,
    [reportTypes.dataVizTemplate]: pageRoutes.dataViz
};
